import { Marketplace } from './';
import {JsonProperty} from 'json-typescript-mapper';

export class Electricmeter {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketplaceNumber')
  public marketplaceNumber?: string;

  @JsonProperty('provider')
  public provider?: string;

  @JsonProperty('count230V')
  public count230V?: number;

  @JsonProperty('count380V')
  public count380V?: number;

  @JsonProperty('factor')
  public factor?: number;

  @JsonProperty('owner')
  public owner?: string;

  @JsonProperty('electricmeterNumber')
  public electricmeterNumber?: string;

  @JsonProperty('location')
  public location?: string;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty('lastValue')
  public lastValue?: number;

  @JsonProperty('lastValueChanged')
  public lastValueChanged?: any;

  @JsonProperty({clazz: Marketplace, name: 'marketplace'})
  public marketplace?: Marketplace;

  @JsonProperty('archived')
  public archived?: boolean;

  constructor() {
    this.id =  void 0;
    this.marketplaceNumber =  void 0;
    this.provider =  void 0;
    this.count230V =  void 0;
    this.count380V =  void 0;
    this.factor = void 0;
    this.owner =  void 0;
    this.electricmeterNumber =  void 0;
    this.location =  void 0;
    this.updated =  void 0;
    this.created =  void 0;
    this.gguid =  void 0;
    this.lastValue = void 0;
    this.lastValueChanged = void 0;
    this.marketplace =  void 0;
    this.archived = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/electricmeter.model.ts